module.exports = __webpack_public_path__ + "static/media/mrh-policy-number.8fed5a88.png";